import { Box } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { Button } from '~/components/ui'
import { URLConstants } from '~/libs/constants'

const TEXT_LINKS = [
  { i18nKey: 'go_to_faq', href: 'https://potent-move-22f.notion.site/samansa-support' },
  { i18nKey: 'about', href: URLConstants.homepage },
  { i18nKey: 'terms', href: URLConstants.terms },
  { i18nKey: 'privacy_policy', href: URLConstants.policy },
] as const

export const AppFooterTextLinks = () => {
  const { t } = useTranslation()

  return (
    <Box
      display='flex'
      alignItems='center'
      gap='8px'
      sx={{ '& .MuiButton-root': { minHeight: 0 } }}
    >
      {TEXT_LINKS.map(({ i18nKey, href }) => (
        <Button
          key={i18nKey}
          variant='text'
          color='secondary'
          onClick={() => window.open(href, '_blank', 'noopener,noreferrer')}
        >
          {t(i18nKey)}
        </Button>
      ))}
    </Box>
  )
}
